import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

const PUBLIC_API_PATTERNS: string[] = [
  'api/1.0/service/airport/getAirportsAsync',
  'api/1.0/service/airline/getAirlinesAsync',
  'api/1.0/service/flighthistory/getFlightHistoryAsync',
  'api/1.0/enum/getRouteTypeAsync',
  '/api/1.0/enum/getDelayTypeAsync',
  '/api/1.0/enum/getNoticePeriodAsync',
  '/api/1.0/enum/getDeniedStatusAsync',
  '/api/1.0/enum/getDisruptionTypeAsync',
  '/api/1.0/user/login/userLoginAsyn',
  '/api/1.0/register/addUserAsync',
  '/api/1.0/otp/sendOTPAsync',
  '/api/1.0/enum/getCountryInfoAsync',
  '/api/1.0/enum/getTextServiceTypeAsync',
];
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const dialog = inject(MatDialog);

  const isPublicApi = PUBLIC_API_PATTERNS.some((pattern) =>
    req.url.includes(pattern)
  );

  let modifiedReq = req;

  if (isPublicApi) {
    modifiedReq = req.clone({
      setHeaders: {
        'Api-Key': 'kF8tZ2rA9QxMnE7Gb1TcVDjP4HsYwNR0Lq5hBUpoXey3WKi6adClSfOGJz',
      },
    });
  } else {
    const token = localStorage.getItem('token');
    if (token) {
      modifiedReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
      ``;
    }
  }
  return next(modifiedReq).pipe(
    catchError((error: HttpErrorResponse) => {
      console.error('Interceptor caught error:', error);
      console.error('Raw error:', JSON.stringify(error, null, 2));
      return throwError(() => error);
    })
  );
};
